import React from 'react'
import PropTypes from 'prop-types'

const IconAttendants = ({ className }) => (
  <svg className={className} viewBox="0 0 15 9">
    <path d="M10 3.875C11.0375 3.875 11.8687 3.0375 11.8687 2C11.8687 0.9625 11.0375 0.125 10 0.125C8.9625 0.125 8.125 0.9625 8.125 2C8.125 3.0375 8.9625 3.875 10 3.875ZM5 3.875C6.0375 3.875 6.86875 3.0375 6.86875 2C6.86875 0.9625 6.0375 0.125 5 0.125C3.9625 0.125 3.125 0.9625 3.125 2C3.125 3.0375 3.9625 3.875 5 3.875ZM5 5.125C3.54375 5.125 0.625 5.85625 0.625 7.3125V8.875H9.375V7.3125C9.375 5.85625 6.45625 5.125 5 5.125ZM10 5.125C9.81875 5.125 9.6125 5.1375 9.39375 5.15625C10.1187 5.68125 10.625 6.3875 10.625 7.3125V8.875H14.375V7.3125C14.375 5.85625 11.4563 5.125 10 5.125Z" />
  </svg>
)

IconAttendants.propTypes = {
  className: PropTypes.string,
}

export default IconAttendants
